export const DRAWER_WIDTH: number = 240;
export const APP_HEADER_NAME: string = "FLEET";
export const COPYRIGHT_LINK: string =
  "https://countyofmonterey.sharepoint.com/sites/ITD";
